import { client } from 'lib/apollo';

import {
    LOGIN,
    REFRESH_TOKEN,
    SEND_OTP,
    CHECK_2FA_METHOD,
    VERIFY_TOTP_LOGIN,
    SETUP_TOTP,
    VERIFY_TOTP_SETUP,
    SET_PREFERRED_2FA_METHOD,
    REGENERATE_BACKUP_CODES,
    DISABLE_TOTP,
    GET_2FA_SETTINGS,
} from './mutation';

export const userLogin = (email: string, password: string, otp: string) =>
    client.mutate({
        mutation: LOGIN,
        variables: {
            email,
            password,
            otp
        },
    });

export const refreshToken = (token: string) =>
    client.mutate({
        mutation: REFRESH_TOKEN,
        variables: {
            token,
        },
    });

export const sendOtp = (email: string, password: string) =>
    client.mutate({
        mutation: SEND_OTP,
        variables: {
            email,
            password,
        },
    });

// TOTP 2FA Functions
export const check2FAMethod = (email: string, password: string) =>
    client.mutate({
        mutation: CHECK_2FA_METHOD,
        variables: {
            email,
            password,
        },
    });

export const verifyTotpLogin = (email: string, password: string, totpCode: string) =>
    client.mutate({
        mutation: VERIFY_TOTP_LOGIN,
        variables: {
            email,
            password,
            totpCode,
        },
    });

export const setupTotp = () =>
    client.mutate({
        mutation: SETUP_TOTP,
    });

export const verifyTotpSetup = (code: string) =>
    client.mutate({
        mutation: VERIFY_TOTP_SETUP,
        variables: {
            code,
        },
    });

export const setPreferred2FAMethod = (method: string) =>
    client.mutate({
        mutation: SET_PREFERRED_2FA_METHOD,
        variables: {
            method,
        },
    });

export const regenerateBackupCodes = () =>
    client.mutate({
        mutation: REGENERATE_BACKUP_CODES,
    });

export const disableTotp = (code: string) =>
    client.mutate({
        mutation: DISABLE_TOTP,
        variables: {
            code,
        },
    });

export const get2FASettings = () =>
    client.mutate({
        mutation: GET_2FA_SETTINGS,
    });
